import type { datadogRum } from '@datadog/browser-rum';

declare global {
  interface Window {
    DD_RUM: typeof datadogRum | undefined;
  }
}

interface ProfileData {
  index: number;
  callTSFileName: string;
  callFunctionName: string;
  start: number;
  total?: number;
}
export class Profile {
  private static index: number = 0;
  public static list: Map<string, ProfileData> = new Map();
  public static start(key: string) {
    const startTime = Date.now();
    if (!this.list.has(key)) {
      const stackTrace = new Error().stack;
      if (stackTrace) {
        // 1번째 줄은 Error Text
        // 2번째 줄은 현재 Start 함수
        const lastCallstack = stackTrace.split('\n')[2];
        const regex = /at\s(.+?)\s.*?\/(.+?)\.ts/g;
        const matches = regex.exec(lastCallstack);

        // 빌드시에는 matches 가 없으므로 else 구문 추가
        if (matches) {
          const temp = matches[2].toString().split('/');
          const fileName = temp[temp.length - 1];

          const temp2 = matches[1].toString().split('.');
          const functionName = temp2[temp2.length - 1];

          this.list.set(key, {
            index: this.index++,
            callTSFileName: fileName,
            callFunctionName: functionName,
            start: startTime,
          });
        } else {
          this.list.set(key, {
            index: this.index++,
            callTSFileName: '',
            callFunctionName: '',
            start: startTime,
          });
        }
      }
    }
  }
  public static end(key: string) {
    if (this.list.has(key)) {
      let data = this.list.get(key)!;
      const end = Date.now();
      if (!data.total) data.total = 0;
      data.total += end - data.start;

      window.DD_RUM?.addTiming(key);
    }
  }
  public static get(key: string) {
    const profileData = this.list.get(key);
    return profileData !== undefined ? profileData.total : undefined;
  }
  public static toString() {
    let texts: string[] = [];
    this.list.forEach((value, key) => {
      if (value.total) {
        texts.push(`${value.callTSFileName}.ts => ${value.callFunctionName}(..) => ${key} : ${value.total}ms`);
      }
    });
    return texts;
  }
  public static print() {
    const texts = this.toString();

    console.log(texts.join('\n'));
  }
  public static reset() {
    this.index = 0;
    this.list.clear();
  }
}
